import AtcFlightRulesLink from './flight-rules-link-component';

import './flight-rules-link.scss';

const MODULE_NAME = 'app.atc.flight.rules-link';
const module = angular.module(MODULE_NAME, [])
    .directive(AtcFlightRulesLink.DIRECTIVE_NAME, AtcFlightRulesLink);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-rules-link/flight-rules-link-module.js